/**
 * File System Access API wrapper for desktop
 * Falls back to file input for mobile
 */

export async function selectVaultFolder(): Promise<FileSystemDirectoryHandle | null> {
  if (!("showDirectoryPicker" in window)) {
    return null;
  }

  try {
    const handle = await (window as any).showDirectoryPicker({
      mode: "read",
    });
    return handle;
  } catch (error: any) {
    if (error.name === "AbortError") {
      return null; // User cancelled
    }
    throw error;
  }
}

export async function readFileFromHandle(
  handle: FileSystemFileHandle
): Promise<File> {
  return await handle.getFile();
}

export async function listFilesInDirectory(
  dirHandle: FileSystemDirectoryHandle
): Promise<FileSystemFileHandle[]> {
  const files: FileSystemFileHandle[] = [];

  for await (const [name, handle] of dirHandle.entries()) {
    if (handle.kind === "file") {
      // Only process supported file types
      const ext = name.toLowerCase().split(".").pop();
      if (["pdf", "docx", "txt", "md"].includes(ext || "")) {
        files.push(handle as FileSystemFileHandle);
      }
    } else if (handle.kind === "directory") {
      // Recursively scan subdirectories
      const subFiles = await listFilesInDirectory(
        handle as FileSystemDirectoryHandle
      );
      files.push(...subFiles);
    }
  }

  return files;
}

/**
 * Mobile fallback: use file input
 */
export function createFileInput(
  accept: string = ".pdf,.docx,.txt,.md",
  multiple: boolean = true
): Promise<FileList | null> {
  return new Promise((resolve) => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = accept;
    input.multiple = multiple;
    input.onchange = (e) => {
      const files = (e.target as HTMLInputElement).files;
      resolve(files);
    };
    input.oncancel = () => resolve(null);
    input.click();
  });
}

